import Repository from '@/repositories/marketing'
import config from "@core/config/app.config.js"
export default {
  
  // Profile tab 
  getProfileData (accountId){
    return Repository.get(`/profile.json`) 
  },
  saveProfileData (accountId, config){
    return Repository.put(`/profile.json`, config)
  },

  // Accounts tab
  getAccountsData (accountId){
    return Repository.get(`/show.json`)
  },
  saveAccountsData(accountId, config){
    return Repository.put(`/update.json`, config)
  },
  saveSMSCompliance(accountId, config){
    return Repository.put(`/sms_compliance_settings.json`, config)
  },
  getUniqueIdentifierColumnsList(accountId){
    return Repository.get(`/custom_fields.json?field_type=string&show_all=true`)
  },
  getIndustriesList(){
    return Repository.get(`/industries.json`,{
      baseURL: `${config.RAILS_BASE_URL}/v2`
    })
  },
  getCountriesList(){
    return Repository.get(`/countries.json`,{
      baseURL: `${config.RAILS_BASE_URL}/v2`
    })
  },
  getStatesList(countryCode){
    return Repository.get(`/countries/${countryCode}/states.json`,{
      baseURL: `${config.RAILS_BASE_URL}/v2`
    })
  },
  deleteContactsList(accountId, config){
    return Repository.post(`/contacts/import_pseudonymize_contacts.json`, config)
  },

  // DNM List Actions For Accounts tab (Global List Section)
  getDnmListContactsCount(accountId){
    return Repository.get(`/general_unsubscribes/count.json`)
  },
  importDnmList(accountId, config){
    return Repository.post(`/general_unsubscribes/import.json`, config)
  },
  exportDnmList(accountId){
    return Repository.get(`/general_unsubscribes/export.json`)
  },
  encryptedExportDnmList(accountId, config){
    return Repository.get(`/general_unsubscribes/export.json`, config)
  },

  // Brand DNM List Actions For Accounts tab (Global List Section)
  getBrandDnmListContactsCount(accountId){
    return Repository.get(`/brand_unsubscribes/count.json`)
  },
  importBrandDnmList(accountId, config){
    return Repository.post(`/brand_unsubscribes/import.json`, config)
  },
  exportBrandDnmList(accountId, config){
    return Repository.get(`/brand_unsubscribes/export.json`, config)
  },
  encryptedExportBrandDnmList(accountId, config){
    return Repository.get(`/brand_unsubscribes/export.json`, config)
  },

  // DNS List Actions For Accounts tab (Global List Section)
  getDnsListContactsCount(accountId){
    return Repository.get(`/sms_unsubscribes/count.json`)
  },
  importDnsList(accountId, config){
    return Repository.post(`/sms_unsubscribes/import.json`, config)
  },
  exportDnsList(accountId){
    return Repository.get(`/sms_unsubscribes/export.json`)
  },

  // Manage DNM List
  getDnmContactsList(accountId, config){
    return Repository.get(`/general_unsubscribes.json`, config)   
  },
  addDnmUser(accountId, config){
    return Repository.post(`/general_unsubscribes.json`, config)
  },
  editDnmUser(accountId, config){
    return Repository.put(`/general_unsubscribes.json`, config)
  },
  deleteDnmUser(accountId, config){
    return Repository.delete(`/general_unsubscribes.json`, config)
  },

  // Manage Brand DNM List
  getBrandDnmContactsList(accountId, config){
    return Repository.get(`/brand_unsubscribes.json`, config)   
  },
  getAllBrandsList(accountId){
    return Repository.get(`/brands.json?per_page=10000000&page=1&method=name&sort_by=asc`)
  },
  addBrandDnmUser(accountId, config){
    return Repository.post(`/brand_unsubscribes.json`, config)
  },
  getUserSpecificBrandData(accountId, brandUserId, config){
    return Repository.get(`/brand_unsubscribes/${brandUserId}.json`, config)
  },
  editBrandDnmUser(accountId, brandUserId, config){
    return Repository.put(`/brand_unsubscribes/${brandUserId}.json`, config)
  },
  deleteBrandDnmUser(accountId, brandUserId, config){
    return Repository.delete(`/brand_unsubscribes/${brandUserId}.json`, config)
  },

  // Manage DNS List
  getDnsContactsList(accountId, config){
    return Repository.get(`/sms_unsubscribes.json`, config)   
  },
  addDnsUser(accountId, config){
    return Repository.post(`/sms_unsubscribes.json`, config)
  },
  editDnsUser(accountId, editUserId, config){
    return Repository.put(`/sms_unsubscribes/${editUserId}.json`, config)
  },
  deleteDnsUser(accountId, deleteDnsId, config){
    return Repository.delete(`/sms_unsubscribes/${deleteDnsId}.json`, config)
  },

  // Manage Accounts
  getSubAccountsData (accountId, config){
    return Repository.get(`/client/accounts.json`, config)
  },
  getClientData (accountId, config){
    return Repository.get(`/client.json`, config)
  },
  getMonthlyEmailUsage (monthlyEmailAccountId){
    return Repository.get(`/${monthlyEmailAccountId}/widgets/monthly_email_usage.json?options=monthly`,{
      baseUrl: `${config.RAILS_BASE_URL}/v2`
    })
  },
  getOwnerData(accountId){
    return Repository.get(`/owner.json`)
  },
  /**
   * get sms volume stats
   * * @returns {Promise} total sms send and receive
   */
  getSmsUsage(accountId, data = {}) {
    const endpoint = `/sms_volume.json`;
    return Repository.get(endpoint, data);
  },
}